<template>
  <div class="contact">
    <h1>{{ $t('contact.title') }}</h1>
    <p>{{ $t('contact.description') }}</p>
    
    <form @submit.prevent="submitForm" class="contact-form">
      <div class="form-group">
        <label for="name">{{ $t('contact.form.name') }}</label>
        <input 
          type="text" 
          id="name" 
          v-model="form.name" 
          :placeholder="$t('contact.form.namePlaceholder')"
          required
        >
      </div>

      <div class="form-group">
        <label for="email">{{ $t('contact.form.email') }}</label>
        <input 
          type="email" 
          id="email" 
          v-model="form.email" 
          :placeholder="$t('contact.form.emailPlaceholder')"
          required
        >
      </div>

      <div class="form-group">
        <label for="message">{{ $t('contact.form.message') }}</label>
        <textarea 
          id="message" 
          v-model="form.message" 
          :placeholder="$t('contact.form.messagePlaceholder')"
          rows="5"
          maxlength="500"
          required
        ></textarea>
      </div>

      <button type="submit" :disabled="isSubmitting">
        {{ isSubmitting ? $t('contact.form.sending') : $t('contact.form.send') }}
      </button>

      <div v-if="submitStatus" :class="['status-message', submitStatus.type]">
        {{ submitStatus.message }}
      </div>
    </form>
  </div>
</template>

<script>
import { sendMail } from '@/utils/flaskapi';

export default {
  name: 'ContactView',
  data() {
    return {
      form: {
        name: '',
        email: '',
        message: ''
      },
      isSubmitting: false,
      submitStatus: null
    }
  },
  methods: {
    async submitForm() {
      this.isSubmitting = true
      this.submitStatus = null

      try {
        const mail_message = await sendMail(this.form.email, this.form.message, this.form.name)
        if (mail_message.message == 'Mail sent') {
        this.submitStatus = {
            type: 'success',
            message: this.$t('contact.form.successMessage')
          }
        } else {
          this.submitStatus = {
            type: 'error',
            message: this.$t('contact.form.errorMessage')
          }
        }
        
        // Clear form
        this.form = {
          name: '',
          email: '',
          message: ''
        }
      } catch (error) {
        this.submitStatus = {
          type: 'error',
          message: this.$t('contact.form.errorMessage')
        }
      } finally {
        this.isSubmitting = false
      }
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Lato:wght@400;700&display=swap');

.contact {
  text-align: center;
  padding: calc(var(--header-height, 100px) + 2rem) 20px 2rem;
  max-width: 800px;
  margin: 0 auto;
  font-family: 'Lato', sans-serif;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.contact h1 {
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  color: var(--text-color);
  margin-bottom: 1rem;
}

.contact p {
  color: var(--text-color);
  margin-bottom: 2rem;
  max-width: 600px;
}

.contact-form {
  text-align: left;
  width: 100%;
  max-width: 600px;
  background-color: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.form-group {
  margin-bottom: 1.5rem;
  width: 100%;
}

label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 700;
  font-family: 'Lato', sans-serif;
  color: var(--text-color);
}

input, textarea {
  width: 100%;
  padding: 0.75rem;
  border: 1.5px solid var(--secondary-color-light);
  border-radius: 4px;
  font-size: 1rem;
  font-family: 'Lato', sans-serif;
  background-color: white;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

input:focus, textarea:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(var(--primary-color-rgb), 0.1);
}

button {
  background-color: var(--primary-color);
  border: none;
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s ease;
  width: 100%;
  font-weight: 600;
}

button:hover {
  background-color: var(--primary-color-dark);
}

button:disabled {
  background-color: var(--secondary-color-light);
  cursor: not-allowed;
}

.status-message {
  margin-top: 1rem;
  padding: 1rem;
  border-radius: 4px;
  text-align: center;
  font-weight: 600;
}

.success {
  background-color: #e3f2ed;
  color: #2c7a5d;
}

.error {
  background-color: #fde8e8;
  color: #c81e1e;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .contact {
    padding: calc(var(--header-height, 100px) + 1rem) 1rem 1rem;
  }

  .contact-form {
    padding: 1.5rem;
  }
}
</style> 